import { MenuPoint, NavColor, NavColors } from '@agilox/ui-common';
import { Component, input, output, signal } from '@angular/core';
@Component({
	selector: 'ui-mobile-nav-list',
	templateUrl: './mobile-nav-list.component.html',
	standalone: false,
})
export class MobileNavListComponent {
	isOpen = input<boolean>(false);
	submenuItems = input<MenuPoint[] | undefined>(undefined);
	navColor = input<NavColor>(NavColors.Dark);
	currentUrl = input<string>('');

	closeMenu = output<void>();
	callbackEvent = output<MenuPoint>();

	currentlyOpenedSubmenu = signal<MenuPoint | undefined>(undefined);

	toggleEntry(item: MenuPoint) {
		if (item.callback) {
			this.callbackEvent.emit(item);
			return;
		}
		if (!item.submenus?.length) {
			this.closeMenu.emit();
			return;
		}

		if (this.currentlyOpenedSubmenu() === item) {
			this.currentlyOpenedSubmenu.set(undefined);
		} else {
			this.currentlyOpenedSubmenu.set(item);
			this.scrollIntoView(item);
		}
	}

	scrollIntoView(item: MenuPoint) {
		const element = document.querySelector(`[data-id="sub-nav-entry-${item.name}"]`);
		if (element) {
			/** Timeout needed for scrollIntoView to work because of the animation */
			setTimeout(() => {
				element.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}, 100);
		}
	}

	private stripQueryParams(url: string): string {
		return url ? url.split('?')[0] : url;
	}

	childrenAreActive(item: MenuPoint): boolean {
		if (item.submenus) {
			const urlWithoutParams = this.stripQueryParams(this.currentUrl());
			return item.submenus.some((submenu: MenuPoint) => {
				let active: boolean = false;
				if (submenu.url) {
					active = urlWithoutParams?.includes(submenu.url);
				}
				if (submenu.active !== undefined) {
					active = submenu.active;
				}
				return active;
			});
		}
		return false;
	}

	protected readonly open = open;
}
